import * as React from "react";
const SvgDeprecatedField = ({
  title,
  titleId,
  ...props
}) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", height: "1em", fill: "none", viewBox: "0 0 12 12", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("rect", { width: 10.8, height: 10.8, x: 0.6, y: 0.6, stroke: "currentColor", strokeWidth: 1.2, rx: 3.4 }), /* @__PURE__ */ React.createElement("path", { stroke: "currentColor", strokeWidth: 1.2, d: "m4 8 4-4M4 4l4 4" }));
export {
  SvgDeprecatedField as default
};
//# sourceMappingURL=deprecated-field.js.map
